// import LangSelector from "./components/lang-selector";
import SiteHeader from "./components/site-header";
// import NewsSlider from "./components/news-slider";
import ReviewsSlider from "./components/reviews-slider";
import PartnersSlider from "./components/partners-slider";
// import PortalPageSlider from "./components/portal-page-slider";
import HandheldMenu from "./components/handheld-menu";
import CookiesConsent from "./components/cookies-consent";
// import DropdownMenu from "./components/dropdown-menu";
// import Accordion from "./components/accordion";
import NewsletterForm from "./components/newsletter-form";
import DeviceManager from "./utils/device-manager";



(function ($) {
	window.$ = $;

	$(function () {
		const $html = $("html");

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass("touch");

			if (DeviceManager.isIos()) {
				$html.addClass("ios");
			}
		} else {
			$html.addClass("no-touch");
		}

		// IE detection
		if (DeviceManager.isIe11()) {
			$html.addClass("ie11");
		} else if (DeviceManager.isEdge()) {
			$html.addClass("edge");
		}

		// Handheld menu
		// const handheldMenu = new HandheldMenu();

		// General components
		// const langSelector = new LangSelector($(".language-selector"));
		const siteHeader = new SiteHeader($(".site-header"), 20);
		// const dropdownMenu = new DropdownMenu($('.header__nav'));

		// News slider component
		const $newsSliders = $(".news-slider");
		if ($newsSliders.length) {
			$newsSliders.each(function (index, el) {
				const newsSlider = new NewsSlider($(el));
			});
		}

		// Partners slider component
		const $partnersSliders = $(".home-partners__slider");
		if ($partnersSliders.length) {
			$partnersSliders.each(function (index, el) {
				const partnerSlider = new PartnersSlider($(el));
			});
		}

		// Portal page slider component
		const $portalPageSliders = $(".portal-page__header-slider");
		if ($portalPageSliders.length) {
			$portalPageSliders.each(function (index, el) {
				const portalPageSlider = new PortalPageSlider($(el));
			});
		}

		// Reviews slider component
		const $reviewsSlider = $(".reviews__slider");
		if ($reviewsSlider.length) {
			$reviewsSlider.each(function (index, el) {
				const reviewsSlider = new ReviewsSlider($(el));
			});
		}

		// Newsletter form component
		const $newsletterFormElements = $(".footer-block.footer-block--newsletter-style");
		if ($newsletterFormElements.length) {
			$newsletterFormElements.each(function (index, el) {
				const newsletterForm = new NewsletterForm(el);
			});
		}

		// Cookie consent
		if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
			// Tarteaucitron cookie settings
			let tarteaucitronLang = "fr";

			const cookiesConsent = new CookiesConsent(tarteaucitronLang, );
		}

        // Masonry
        /* $('.gallery-section__grid').masonry({
            columnWidth: '.gallery-section__item',
            itemSelector: '.gallery-section__item',
            percentPosition: true,
            gutter: 2,
            horizontalOrder: true
        }); */

		var $grid = $('.gallery-section__grid').imagesLoaded( function() {
			// init Masonry after all images have loaded
			$grid.masonry({
				columnWidth: '.gallery-section__item',
				itemSelector: '.gallery-section__item',
				percentPosition: true,
				gutter: 2,
				horizontalOrder: true
			});
		});

        // Galerie d'images
        $('a.gallery-section__item').colorbox({
            rel:'gal',
            transition: 'fade',
            current: '({current} / {total})',
            slideshow: true,
            slideshowSpeed: 2500,
            slideshowAuto: false
        });

	});
})(jQuery);
